// extracted by mini-css-extract-plugin
export var parcelRow = "_tw-0";